import {useTranslation} from 'react-i18next'
import {Sort} from '../../../../../common/core/entities/sort'

const sortOptions = [
    {value: 'name', label: 'QR_SORT_BY_NAME'},
    {value: 'rating', label: 'QR_SORT_RATING'},
    {value: 'tip', label: 'QR_SORT_TIPS_AMOUNT'},
    {value: 'experience', label: 'QR_SORT_EXPERIENCE'},
] as const

type SortSelectProps = {
    sortBy: Sort | null
    onSort: (s: Sort) => void
}

const SortSelect = ({sortBy, onSort}: SortSelectProps) => {
    const {t} = useTranslation()

    const onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newValue = e.target.value
        if (!newValue) {
            return
        }
        onSort(newValue as Sort)
    }
    return (
        <select
            value={sortBy || ''}
            className={`h-8 appearance-none rounded-full border border-grey-70 bg-white px-3 text-sm ${
                !sortBy ? 'text-grey-20' : 'text-black'
            } min-w-0 text-sm active:border-black`}
            placeholder={t('QR_SORT_PLACEHOLDER')}
            onChange={onChange}
        >
            <option value="" disabled>
                Select your option
            </option>
            {sortOptions.map((op) => (
                <option key={op.value} value={op.value}>
                    {t(op.label)}
                </option>
            ))}
        </select>
    )
}

export default SortSelect
